<template>
    <div>
        <h3 style="text-align:center;">Credit Consulting Contract</h3>
        <p>
            <strong>Prepared For:</strong>
        </p>
        <p class="mb-0">{{ firstName }} {{lastName}}</p>
        <p class="mb-0">{{ address }}</p>
        <p class="mb-0">{{ city }} {{ state }} {{ zipcode }}</p>
        <br>
        Date: <strong>{{ today }}</strong>
        <br>
        <p>This agreement ("Agreement") is made and entered into as of {{today}} ("Effective Date") by and between {{companyName}} with its principal place of business at {{company_city}}, {{company_state}} {{company_zipcode}} the (“Company"), and {{firstName}} {{lastName}} with an address at {{address}}, {{city}}, {{state}} {{zipCode}} the (“Client").</p>
        <p>This Agreement contains the following:</p>
        <ol>
            <li>Credit Consultation Service Agreement</li>
            <li>Authorization for Credit Repair Action</li>
            <li>Consumer Credit File Rights (CROA Disclosure)</li>
            <li>Right Of Cancellation Notice</li>
            <li>Refund Policy</li>
            <li>Acknowledgment of Receipt of Notice</li>
        </ol>
        <h2>Credit Consulting/Credit Repair Services</h2>
        <p>Company agrees to provide Credit Consulting and/or credit repair services to Client.</p>
        <ul>
        <li>Evaluating Client's credit reports from applicable credit reporting agencies and identifying inaccurate, erroneous, false, or obsolete information.</li>
        <li>Advising Client on the necessary steps to be taken in conjunction with Company to dispute any inaccurate, erroneous, false, or obsolete information contained in Client's credit reports.</li>
        <li>Preparing all necessary correspondence to dispute inaccurate, erroneous, false, or obsolete information in Client's credit reports.</li>
        <li>Reviewing credit profile status from credit reporting agencies such as Experian, Equifax, and TransUnion.</li>
        <li>Providing consulting, coaching, and monitoring services through personal meetings, webinars, video conferencing, telephone, email, or other forms of communication during normal business hours.</li>
        <li>Assisting with goal setting and accountability related to Client's finances.</li>
        </ul>
        <p>Fees, In exchange for the services provided by Company, Client agrees to pay the following fees as outlined in the fee schedule below:</p>
        <ul>
        <li>${{consultation_fee}} at signup for document processing. This fee is not for credit repair services, but for the processing of Client's documents and Consultation. This fee is non-refundable.</li>
        <li>${{service_fee}} every 30 days from the document processing for the previous 30 days of service. All fees are paid after work has been completed.</li>
        </ul>
        <h3>Authorization for Credit Repair Action. </h3>
        <p>Client authorizes Company to electronically debit their checking account or credit card for the aforementioned fees effective as of the date of this Agreement.</p>
        <h3>Credit Repair Action Authorization</h3>
        <p>
            Client authorizes Company to make, receive, sign, endorse, execute, acknowledge, deliver, and possess such applications, correspondence, contracts, or agreements as 
            necessary to improve Client's credit with the three credit reporting agencies: TransUnion, Experian, Equifax, and any other reporting agencies or creditors as may be 
            necessary or proper in the exercise of the rights and powers granted herein. Client may revoke this authorization at any time by giving written notice to Company, but 
            any activity made prior to revocation in reliance upon this authorization shall not constitute a breach of Client's rights. This authorization automatically expires 12 
            months from the date of signature. Client also grants Company the authority to take any necessary actions to improve their credit with the aforementioned credit reporting agencies.
        </p>
        <h3>Release of Liability</h3>
        <p>Client releases Company from all claims, actions, and demands arising out of or related to the services provided under this Agreement.</p>
        <h3>State-Specific Disclosures</h3>
        <p>If applicable, any state-specific disclosures will be added to this Agreement as an addendum.</p>
        <h3>Consumer Credit File Rights (CROA Disclosure)</h3>
        <p>
            Client has certain rights under state and federal law, including the right to dispute inaccurate information in their credit report, 
            the right to obtain a copy of their credit report, and the right to sue a credit repair organization that violated the Credit Repair 
            Organization Act. Client's right to cancel this Agreement within three business days of signing it is also acknowledged. Further details 
            are provided in the CROA Disclosure section.
        </p>
        <h3>Cancellation Notice</h3>
        <p>You have the right to cancel this Agreement within three business days of signing it by giving written notice to the Company at the address specified below:</p>
        <p>{{ company_address }}</p>
        <h3>
            Consumer Credit File Rights (CROA Disclosure)
        </h3>
        <p>
            Under state and federal law, you have the right to dispute inaccurate information in your credit report by contacting the credit bureau directly. However, 
            neither you nor a credit repair company or credit repair organization has the right to have accurate, current, and verifiable information removed from your 
            credit report. The credit bureau must remove accurate, negative information from your report only if it is over 7 years old. Bankruptcy information can be 
            reported up to 10 years.
        </p>
        <p>
            You Have the Right to Obtain a Copy of Your Credit Report You may be charged a reasonable fee. There is no fee, however, if you have been turned down for credit, 
            employment, insurance, or a rental dwelling because of information in your credit report within the preceding 60 days. The credit bureau must provide someone to 
            help you interpret the information in your credit file. You are entitled to receive a free copy of your credit report if you are unemployed and intend to apply for 
            employment in the next 60 days, if you are a recipient of public welfare assistance, or if you have reason to believe that there is inaccurate information in your 
            credit report due to fraud.
        </p>
        <p>
            You Have the Right to Sue a Credit Repair Organization This law prohibits deceptive practices by credit repair organizations.
        </p>
        <p>
            You have the right to cancel your contract with any credit repair organization for any reason within three business days from the date you signed it.
        
            Credit bureaus are required to follow reasonable procedures to ensure that the information they report is accurate. However, mistakes may occur.
        </p>
        <p>
            You may, on your own, notify a credit bureau in writing that you dispute the accuracy of information in your credit file. The credit bureau must then 
            reinvestigate and modify or remove inaccurate or incomplete information. The credit bureau may not charge any fee for this service. Any pertinent information 
            and copies of all documents you have concerning an error should be given to the credit bureau.
        </p>
        <p> 
            If the credit bureau's reinvestigation does not resolve the dispute to your satisfaction, you may send a brief statement to the credit bureau to be kept in your 
            file, explaining why you think the record is inaccurate. The credit bureau must include a summary of your statement about disputed information with any report it issues about you.
            The Federal Trade Commission regulates credit bureaus and credit repair organizations. For more information, contact: 
            <br>
            The Public Reference Branch, Federal Trade Commission, Washington, D.C. 20580.
        </p>
        <h3>Right Of Cancellation Notice.</h3>
        <p>
            You may cancel this contract, without any penalty or obligation, at any time. Upon notice of your cancellation, we will set your account to no longer bill immediately. 
            To cancel this contract, email, mail, or deliver a signed, dated copy of this cancellation notice, or any other written notice, to {{companyName}}, {{company_city}}, {{company_state}} 
            {{company_zipcode}}, anytime after the date you have signed this contract stating "I hereby cancel this transaction, (date) (purchaser's signature)."
        </p>
        <h3>Refund Policy:</h3>
        <p>
            If you have been a {{companyName}} client for at least 120 days and we are unable to update/remove ANYTHING from your credit report, you will receive a full refund. (Minus the credit audit fee) 
            under the following circumstances:
        </p>
        <ol>
            <li>If we do not remove anything from your credit report and you've obtained our services for 120 days.</li>
            <li>You have not used a credit repair company nor attempted to repair your credit at least two years before signing up for our services.</li>
            <li>You have had no new items or missed payments added during the time frame we are assisting you.</li>
            <li>You agree & have sent updated reports/responses from the three credit bureaus & creditors to us within five days of receipt.</li>
        </ol>
        <h3>Acknowledgment of Receipt of Notice. </h3>
        <p>
            By electronically signing this Agreement, Client acknowledges receipt of the Notice of Right to Cancel and confirms that they understand 
            and agree to the terms outlined in this Agreement, including the fee schedule and authorization for credit repair action. Client also acknowledges 
            that they have received a copy of their Consumer Credit File Rights.
        </p>
        <h3>
            State-Specific Disclosures (add if applicable)
        </h3>
        <p>
            If any state-specific disclosures are required, they will be added to this Agreement as Exhibit B and incorporated herein by reference. 
        </p>
        <h3>Entire Agreement</h3>
        <p>
            This Agreement constitutes the entire agreement between the parties and supersedes all prior agreements and understandings, whether written 
            or oral, relating to the subject matter of this Agreement. This Agreement may not be amended except in writing signed by both parties.
        </p>

        <h3>Governing Law and Jurisdiction</h3>Headings
        The headings in this Agreement are for convenience only and shall not affect the interpretation of this Agreement.
        
        I, {{ firstName }} {{lastName}}, hereby acknowledge with my digital signature, receipt of the Notice of Right to Cancel. I confirm the fact that I agree and understand what 
        I am signing, and acknowledge that I have received a copy of my Consumer Credit File Rights.  Digital Signatures: In 2000, the U.S. Electronic Signatures in 
        Global and National Commerce (ESIGN) Act established electronic records and signatures as legally binding, having the same legal effects as traditional paper 
        documents and handwritten signatures. Read more at the FTC web site: http://www.ftc.gov/os/2001/06/esign7.htm
        <p>
            This Agreement shall be governed by and construed in accordance with the laws of the state in which {{companyName}} is located, without regard to 
         conflicts of law principles. Any dispute arising out of or relating to this Agreement shall be resolved in the state or federal courts located in the county where {{companyName}} is located.
        </p>
        <h3>Assignment</h3>
        <p>
            This Agreement may not be assigned by either party without the prior written consent of the other party.
        </p>
        <h3>Waiver</h3>
        <p>
            The failure of either party to enforce any provision of this Agreement shall not be deemed a waiver of such provision or of the right to enforce such provision.
        </p>
        <h3>Severability</h3>
        <p>
            If any provision of this Agreement is held to be invalid or unenforceable for any reason, the remaining provisions will continue in full force and effect.
        </p>
        <h3>Headings</h3>
        <p>The headings in this Agreement are for convenience only and shall not affect the interpretation of this Agreement.</p>
        <p>
            I, {{ firstName }} {{lastName}}, hereby acknowledge with my digital signature, receipt of the Notice of Right to Cancel. I confirm the fact that I agree and understand what 
            I am signing, and acknowledge that I have received a copy of my Consumer Credit File Rights.  Digital Signatures: In 2000, the U.S. Electronic Signatures in 
            Global and National Commerce (ESIGN) Act established electronic records and signatures as legally binding, having the same legal effects as traditional paper 
            documents and handwritten signatures. Read more at the FTC web site: http://www.ftc.gov/os/2001/06/esign7.htm
        </p>

        <p>This Agreement may be executed by electronic signature, which shall be deemed to be an original signature for all purposes.</p>
        <p>
            IN WITNESS WHEREOF, the parties have executed this Agreement as of the date first written above.
        </p>
        <p>
            {{companyName}}
            <br>
            {{firstName}} {{lastName}}
        </p>
        

        
  </div>
</template>
<script>
export default {
  data() {
    return {
      companyName: "{{companyName}}",
      company_address: "{{company_address}}",
      company_city: "{{company_city}}",
      company_state: "{{company_state}}",
      company_zipcode: "{{company_zipcode}}",
      firstName: "{{firstName}}",
      lastName: "{{lastName}}",
      address: "{{address}}",
      city: "{{city}}",
      state: "{{state}}",
      zipCode: "{{zipCode}}",
      today:"{{today}}",
      consultation_fee:"{{consultation_fee}}",
      service_fee:"{{service_fee}}"
    };
  }
};
</script>
